module.exports = __webpack_public_path__ + "img/bay-breeze.d9008c40.jpg";